import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import ArtistCard from "./ArtistCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllArtist } from "store/actions";
import { Oval } from 'react-loader-spinner'
import InfiniteScroll from 'react-infinite-scroll-component';
export default function ArtistViewAll(props) {
  const dispatch = useDispatch();
  const { allArtists, loading, totalArtists } = useSelector((selector) => selector?.museums)
  const [activePage, setActivePage] = useState(1);
  const [artists, setArtists] = useState([])
  const [ovalLoading, setOvalLoading] = useState(true)
  const [filter, setfilter] = useState({
    limit: 12,
    orderBy: "_id",
    order: 1,
    page: 1,
    collectedAuthor: "",
    author: "",
    createdAuthor: "",
    collectionId: "",
    fields: [{
      fieldName: "role",
      fieldValue: "ARTIST"
    },
    {
      fieldName: "subcategory_id",
      fieldValue: ""
    }
    ],
    fileType: [],
    isVarified: false,
    getNew: false,
    isMore: false,
  });
  useEffect(() => {
    const callback=(res)=>{
      setOvalLoading(false)
    }
    dispatch(getAllArtist(filter, callback))

  }, [filter, dispatch])
  useEffect(() => {
    let data = [...artists, ...allArtists]
    function removeDuplicatesById(arr) {
      const seenIds = new Set();
      return arr.filter(item => {
        if (seenIds.has(item._id)) {
          return false;
        } else {
          seenIds.add(item._id);
          return true;
        }
      });
    }
    const uniqueItems = removeDuplicatesById(data);

    setArtists(uniqueItems)
  }, [totalArtists, allArtists])


  const fetchDataOnScroll = () => {
    setfilter((prev) => ({ ...prev, page: activePage + 1 }))
    setActivePage(activePage + 1)
  }
  return (
    <>
      {ovalLoading &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      <div className="position-relative">
        <Header />
        <div className="gradientBg">
          <div className="container-fluid profileBox dashboardprofile">
            <Row>
              <Col lg={12}>
                <h1>ARTIST</h1>
              </Col>
            </Row>
          </div>
        </div>
        <Container>
          <Row className="py-5">
            {artists.length > 0 ? (
              <Col lg={12}>
                <InfiniteScroll className="row"
                  dataLength={artists.length} //This is important field to render the next data
                  next={fetchDataOnScroll}
                  hasMore={artists?.length < totalArtists}
                  loader={loading && <h4>Loading...</h4>}
                  endMessage={
                    <p style={{ textAlign: 'center' }}>
                      <b>{""}</b>
                    </p>
                  } >
                  {artists?.map((data, idx) => {
                    return (
                      <Col className="mb-4" lg={3} key={idx}>
                        <ArtistCard data={data} />
                      </Col>
                    );
                  })}
                </InfiniteScroll>
              </Col>
            ) : (
              <>
                <div className="text-center d-grid justify-content-center dataNotFound py-5">
                  <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                  <h3>No Artist Available</h3>
                </div>
              </>
            )}

          </Row>
        </Container>
        <Footer />
      </div>
    </>
  );
}
